module.exports = __webpack_public_path__ + "img/bell.ced4474b.svg";